<template>
  <v-form v-model="valid">
    <v-container>
      <v-layout
        row
        wrap
      >
        <v-flex xs12>
          <h2 v-if="$route.params.edit">{{ $vuetify.t('$vuetify.lobis.editTimeEntry') }}</h2>
          <h2 v-else>{{ $vuetify.t('$vuetify.lobis.addTimeEntry') }}</h2>
        </v-flex>
        <v-flex xs12>
          <salesLine
            v-if="$route.params.line"
            :salesLine=$route.params.line
            :editable=false
          ></salesLine>
          <v-flex xs12 mb-2 v-else-if="$route.params.edit && $route.params.edit.sales_order_line">
            <v-card>
                <v-layout xs12>
                    <v-flex xs3 text-xs-center>
                        {{ $route.params.edit.sales_order_line.article }}
                    </v-flex>
                    <v-flex xs9>
                        <p :class="{ underline: $route.params.edit.sales_order_line.qty_to_do, 'font-weight-bold': $route.params.edit.sales_order_line.print_attribute }" >{{ $route.params.edit.sales_order_line.name }}</p>
                        <p>{{ $route.params.edit.sales_order_line.description }}</p>
                    </v-flex>
                </v-layout>
            </v-card>
          </v-flex>
          <customer-select v-else :customer.sync="customer" :project.sync="project"></customer-select>
        </v-flex>
        <div v-if="$store.getters.hasPermission('fe_timeentry_time')">

        <v-flex
          xs12
          sm6
          md3
        >
          <v-dialog
            ref="dateDialog"
            v-model="dateModal"
            :return-value.sync="date"
            persistent
            lazy
            full-width
            width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="dateFormatted"
              :label="$vuetify.t('$vuetify.lobis.date')"
              prepend-icon="event"
              readonly
              @blur="date = parseDate(dateFormatted)"
            ></v-text-field>
            <v-date-picker
              v-model="date"
              scrollable
              first-day-of-week="1"
            >
              <v-spacer></v-spacer>
              <v-btn
                flat
                color="primary"
                @click="dateModal = false"
              >{{ $vuetify.t('$vuetify.lobis.cancel') }}</v-btn>
              <v-btn
                flat
                color="primary"
                @click="$refs.dateDialog.save(date)"
              >{{ $vuetify.t('$vuetify.lobis.ok') }}</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-flex>
        <v-flex
          xs12
          md3
        >
          <v-dialog
            ref="startDialog"
            v-model="startModal"
            :return-value.sync="start"
            persistent
            lazy
            full-width
            width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="start"
              :label="$vuetify.t('$vuetify.lobis.begin')"
              prepend-icon="access_time"
              readonly
            ></v-text-field>
            <v-time-picker
              v-if="startModal"
              v-model="start"
              full-width
              format="24hr"
            >
              <v-spacer></v-spacer>
              <v-btn
                flat
                color="primary"
                @click="startModal = false"
              >{{ $vuetify.t('$vuetify.lobis.cancel') }}</v-btn>
              <v-btn
                flat
                color="primary"
                @click="$refs.startDialog.save(start)"
              >{{ $vuetify.t('$vuetify.lobis.ok') }}</v-btn>
            </v-time-picker>
          </v-dialog>
        </v-flex>
        <v-flex
          xs12
          md3
        >
          <v-dialog
            ref="endDialog"
            v-model="endModal"
            :return-value.sync="end"
            persistent
            lazy
            full-width
            width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="end"
              :label="$vuetify.t('$vuetify.lobis.end')"
              prepend-icon="access_time"
              readonly
            ></v-text-field>
            <v-time-picker
              v-if="endModal"
              v-model="end"
              full-width
              format="24hr"
            >
              <v-spacer></v-spacer>
              <v-btn
                flat
                color="primary"
                @click="endModal = false"
              >{{ $vuetify.t('$vuetify.lobis.cancel') }}</v-btn>
              <v-btn
                flat
                color="primary"
                @click="$refs.endDialog.save(end)"
              >{{ $vuetify.t('$vuetify.lobis.ok') }}</v-btn>
            </v-time-picker>
          </v-dialog>
        </v-flex>
        <v-flex xs12 md3>
          <v-text-field
              v-model="duration"
              :label="$vuetify.t('$vuetify.lobis.duration')"
              prepend-icon="access_time"
              readonly
            ></v-text-field>
        </v-flex>
        </div>

        <v-flex
          xs12
          md4
        >
          <v-text-field
            :name="$vuetify.t('$vuetify.lobis.squaremeters')"
            :label="$vuetify.t('$vuetify.lobis.qtyDone', ($route.params.line ? $route.params.line.unity : $vuetify.t('$vuetify.lobis.qty')))"
            id="id"
            v-model="qty"
            v-validate="'required|decimal'"
            :error-messages="errors.collect('qty')"
            data-vv-name="qty"
            type="number"
          ></v-text-field>
        </v-flex>
        <v-flex
          xs12
          md8
        >
          <v-textarea
            :name="$vuetify.t('$vuetify.lobis.note')"
            :label="$vuetify.t('$vuetify.lobis.note')"
            id="id"
            rows="3"
            v-model="description"
            box
          ></v-textarea>
        </v-flex>
        <v-flex xs12 v-if="!$route.params.line">
          <v-switch
            v-model="regie"
            label="Regie"
          ></v-switch>
        </v-flex>
        <v-flex xs12>
          <v-btn
            color="error"
            @click="$router.go(-1)"
          >{{ $vuetify.t('$vuetify.lobis.cancel') }}</v-btn>
          <v-btn
            color="primary"
            @click="add()"
            v-if="$route.params.edit"
          >{{ $vuetify.t('$vuetify.lobis.edit') }}</v-btn>
          <v-btn
            color="primary"
            @click="add()"
            v-else
          >{{ $vuetify.t('$vuetify.lobis.add') }}</v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import { mapGetters } from 'vuex'
import { SALESLINE_GET } from '../../store/actions/salesOrder'
import salesLine from '../SalesOrder/SalesLine.vue'
import { TIMEENTRY_ADD } from '../../store/actions/timeEntry'
import customerSelect from '../Formcomponents/CustomerSelect.vue'

export default {
  components: { salesLine, customerSelect },
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      start: this.$route.params.edit ? this.$moment(this.$route.params.edit.begin, 'YYYY-MM-DD HH:mm:ss').format('HH:mm') : '07:00',
      end: this.$route.params.edit ? this.$moment(this.$route.params.edit.end, 'YYYY-MM-DD HH:mm:ss').format('HH:mm') : this.$moment().format('HH:mm'),
      date: this.$route.params.edit ? this.$moment(this.$route.params.edit.begin, 'YYYY-MM-DD HH:mm:ss').toISOString().substr(0, 10) : new Date().toISOString().substr(0, 10),
      // dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
      startModal: false,
      endModal: false,
      dateModal: false,
      valid: true,
      qty: this.$route.params.edit ? this.$route.params.edit.qty : null,
      regie: this.$route.params.edit ? this.$route.params.edit.regie : null,
      id: this.$route.params.edit ? this.$route.params.edit.id : null,
      description: this.$route.params.edit ? this.$route.params.edit.description : '',
      customer: this.$route.params.edit ? this.$route.params.edit.customer : null,
      project: this.$route.params.edit ? this.$route.params.edit.project : null
    }
  },
  mounted () {
  },
  computed: {
    ...mapGetters([
      SALESLINE_GET
    ]),
    items () {
      return this.autocomplete.entries.map(entry => {
        const Description = entry.name

        return Object.assign({}, entry, { Description })
      })
    },
    dateFormatted () {
      return this.formatDate(this.date)
    },
    duration () {
      var start = this.$moment(this.date + ' ' + this.start)
      var end = this.$moment(this.date + ' ' + this.end)
      return this.$moment.utc(this.$moment.duration(end.diff(start)).as('milliseconds')).format('HH:mm')
    }
  },
  methods: {
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    add () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (!this.$route.params.line && !this.customer) {
            this.$swal({
              type: 'error',
              title: this.$vuetify.t('$vuetify.lobis.selectCustomer')
            })
            return
          }
          if (!this.$route.params.line && this.customer && this.customer.projects.length && !this.project) {
            this.$swal({
              type: 'error',
              title: this.$vuetify.t('$vuetify.lobis.selectProject')
            })
            return
          }
          this.$swal({
            title: this.$vuetify.t('$vuetify.lobis.sending'),
            onBeforeOpen: () => {
              this.$swal.showLoading()
            }
          })

          var data = {
            qty: this.qty,
            description: this.description
          }

          if (this.$store.getters.hasPermission('fe_timeentry_time')) {
            data.begin = this.$moment(this.date + ' ' + this.start).format('YYYY-MM-DD HH:mm:ss')
            data.end = this.$moment(this.date + ' ' + this.end).format('YYYY-MM-DD HH:mm:ss')
          }

          if (this.$route.params.line) {
            if (this.$route.params.line.sales_order_id) {
              data.sales_order_id = this.$route.params.line.sales_order_id
            } else {
              data.sales_line_id = this.$route.params.line.id
            }
          } else if (this.$route.params.edit) {
            data.id = this.$route.params.edit.id
            if (this.$route.params.edit.sales_order_line) {
              data.sales_line_id = this.$route.params.edit.sales_order_line.id
            }
            if (this.customer) {
              data.customer_id = this.customer.id
              if (this.project) {
                data.project_id = this.project.id
              }
            }
          } else {
            data.customer_id = this.customer.id
            if (this.project) {
              data.project_id = this.project.id
            }
          }

          this.$store.dispatch(TIMEENTRY_ADD, data).then(resp => {
            this.$swal({
              type: 'success',
              title: this.$vuetify.t('$vuetify.lobis.addedSuccessfully'),
              showConfirmButton: false,
              timer: 1500
            })
            this.$router.push('/')
          }
          ).catch(err => {
            let errorMessage = err.data.message
            window._.each(err.data.errors, (field) => {
              window._.each(field, (message) => {
                errorMessage += '<br>' + message
              })
            })
            this.$swal(errorMessage)
          })
        }
      })
    }
  },
  watch: {
    date (val) {
      this.dateFormatted = this.formatDate(this.date)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CreateTimeEntry/Index.vue